import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-631c3db4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search-box"
};
const _hoisted_2 = {
  class: "table-container table-box"
};
const _hoisted_3 = {
  class: "page-box"
};
const _hoisted_4 = {
  class: "dialog-footer"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加");

export default {
  props: {
    show: Boolean
  },
  emits: ["update:show", 'updateAuthList'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $http = inject("$http");
    const siteId = inject('siteId');
    const searchInfo = reactive({
      keyWord: '',
      organ_id: ''
    });
    const orgTreeList = ref([]);
    const orgProps = reactive({
      checkStrictly: true,
      emitPath: false,
      value: 'id',
      label: 'organName'
    });
    const teacherList = ref([]);
    const pageInfo = reactive({
      pageNum: 1,
      pageSize: 10,
      total: 0
    });
    const selectedUser = ref([]);

    const handleClose = () => {
      emit("update:show", false);
    };

    const handleSearch = () => {
      pageInfo.pageNum = 1;
      getTeacherList();
    }; // 选中的


    const handleSelectionChange = item => {
      selectedUser.value = item.map(item => item.user_id);
    };

    const handlePageChange = index => {
      pageInfo.pageNum = index;
      getTeacherList();
    };

    const handleSizeChange = val => {
      pageInfo.pageSize = val;
      pageInfo.pageNum = 1;
      getTeacherList();
    }; // 获取机构树


    const getOrgTree = async () => {
      const res = await $http.getOrganTree();
      orgTreeList.value = res;
    }; // 添加协作者-待选列表


    const getTeacherList = async () => {
      let params = {
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        site_id: siteId,
        keyWord: searchInfo.keyWord || undefined,
        organ_id: searchInfo.organ_id || undefined
      };
      const res = await $http.addCollaborationByChoice(params);
      teacherList.value = res.content || [];
      pageInfo.total = +res.totalElements;
    };

    getOrgTree();
    getTeacherList(); // 提交

    const handleAdd = async () => {
      if (!selectedUser.value.length) {
        ElMessage.warning('未选择任何协作者');
        return;
      }

      let params = {
        user_id: selectedUser.value.join(),
        site_id: siteId,
        status: 2
      };
      const data = await $http.addCollaboration(params);
      ElMessage.success('已邀请');
      emit('updateAuthList');
      handleClose();
    };

    return (_ctx, _cache) => {
      const _component_search = _resolveComponent("search");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(show) ? show.value = $event : null),
        width: "980px",
        "append-to-body": true,
        title: "添加协作者",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: handleAdd
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: _unref(searchInfo).keyWord,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchInfo).keyWord = $event),
          class: "input-box",
          size: "large",
          onKeyup: _withKeys(handleSearch, ["native", "enter"]),
          placeholder: "请输入教师名称"
        }, {
          suffix: _withCtx(() => [_createVNode(_component_el_icon, {
            onClick: handleSearch
          }, {
            default: _withCtx(() => [_createVNode(_component_search)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_cascader, {
          modelValue: _unref(searchInfo).organ_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(searchInfo).organ_id = $event),
          onChange: handleSearch,
          clearable: true,
          size: "large",
          "show-all-levels": false,
          options: orgTreeList.value,
          props: _unref(orgProps),
          placeholder: "所属机构",
          style: {
            "width": "236px"
          }
        }, null, 8, ["modelValue", "options", "props"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
          data: teacherList.value,
          height: "300",
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            property: "usercode",
            align: "center",
            label: "工号",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            property: "realname",
            align: "center",
            label: "姓名",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            property: "organ_name",
            align: "center",
            label: "所属机构",
            "min-width": "130"
          }), _createVNode(_component_el_table_column, {
            property: "phone",
            align: "center",
            label: "绑定手机号",
            "min-width": "130"
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
          onCurrentChange: handlePageChange,
          "page-size": _unref(pageInfo).pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = $event => _unref(pageInfo).pageSize = $event),
          "page-sizes": [10, 20, 30, 40],
          "current-page": _unref(pageInfo).pageNum,
          "onUpdate:current-page": _cache[3] || (_cache[3] = $event => _unref(pageInfo).pageNum = $event),
          onSizeChange: handleSizeChange,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(pageInfo).total
        }, null, 8, ["page-size", "current-page", "total"])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};